module.exports = __webpack_public_path__ + "media/images/pic/banners/online-learning-dc3b831a8a0f694e6c731d521ed613af.svg";